import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { FiImageSize } from '@fi-shared/types';
import { FiWrapperTableAdditionalColumns } from '@fi-shared/fi-wrapper-table/fi-wrapper-table-additional-columns';
import { IChecklist2ReportAnswer } from '@fi-shared/checklist/fi-checklist2-report/shared/fi-checklist2-report';
import { IMediaBankFileReference } from '@fi-shared/media-bank';
import { FiChecklist2ReportDialogsService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-dialogs.service';

@Component({
    selector: 'fi-checklist2-answer-attachments',
    template: `
        <ng-container matColumnDef="MediaBankFileReferences">
            <mat-header-cell *matHeaderCellDef>
                <fi-wrapper-table-span-cell [value]="'common.attachments' | fiAppText" />
            </mat-header-cell>

            <mat-cell *matCellDef="let item" class="column-show-mobile">
                <fi-attachments-list
                    [isNoMarginAttachments]="isNoMarginAttachments"
                    [isCustomPreviewHandler]="true"
                    (attachmentClick)="showAttachmentDetails(item, $event)"
                    [isPdfFilePreviewMode]="true"
                    [isImgDraggable]="false"
                    [mediaBankFileReferences]="item.MediaBankFileReferences"
                    [imageSize]="FiImageSize.Medium"
                >
                </fi-attachments-list>
            </mat-cell>
        </ng-container>
    `,
    styleUrls: ['./fi-checklist2-answer-attachments.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-checklist2-answer-value' },
    providers: [{ provide: FiWrapperTableAdditionalColumns, useExisting: FiChecklist2AnswerAttachmentsComponent }],
    standalone: false,
})
export class FiChecklist2AnswerAttachmentsComponent extends FiWrapperTableAdditionalColumns {
    @Input() isNoMarginAttachments: boolean = false;
    protected readonly FiImageSize = FiImageSize;

    constructor(private fiChecklist2ReportDialogsService: FiChecklist2ReportDialogsService) {
        super();
    }

    showAttachmentDetails(answerDetails: IChecklist2ReportAnswer, mediaBankFileReference: IMediaBankFileReference) {
        this.fiChecklist2ReportDialogsService.showChecklistAttachmentDetailsDialog(
            answerDetails,
            mediaBankFileReference,
        );
    }
}
